module.exports = __webpack_public_path__ + "img/weber_metallbearbeitung_chemo_finish_polieren_01.9067a162.jpg";